export var Name;
(function (Name) {
    Name["Qualifications"] = "qualifications";
    Name["UsrVisible"] = "usr_visible";
})(Name || (Name = {}));
export const values = Object.values(Name);
function allOffCompute() {
    const result = {};
    values.forEach(v => (result[v] = false));
    return result;
}
let allOffValue = null;
export function allOff() {
    let v;
    if (allOffValue)
        v = allOffValue;
    else {
        v = allOffCompute();
        allOffValue = v;
    }
    return Object.assign({}, v);
}
